var TopProductModel = function() {
    var that = this;

    that.IsLoading = ko.observable(false);
    that.ArticleReference = ko.observable();
};